import { Class } from "types";
import { api } from "../api";
import { NetworkError } from "../networkError";

interface Params {
  token: string;
  classId: string;
}

const resetAllStudentPasswords = async ({ token, classId }: Params): Promise<Class> => {
  const response = await api.post(
    `/classes/${classId}/resetallpasswords`,
    {},
    {
      headers: { Authorization: `Bearer ${token}` },
    }
  );
  const newClass: Class = response.data;

  if (newClass) {
    return newClass;
  } else {
    throw new NetworkError();
  }
};

export { resetAllStudentPasswords };
